"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var GlobalNav = /** @class */ (function (_super) {
    __extends(GlobalNav, _super);
    function GlobalNav(props) {
        var _this = _super.call(this, props) || this;
        _this.state = {
            className: (_this.props.options ? _this.props.options.className : ''),
            jsonData: (_this.props.options ? _this.props.options.jsonData : ''),
        };
        return _this;
    }
    GlobalNav.prototype.UNSAFE_componentWillReceiveProps = function (nextProps) {
        var oldOptions = this.props.options;
        var newOptions = nextProps.options;
        if (oldOptions.className !== newOptions.className) {
            this.setState({ className: newOptions.className });
        }
        if (oldOptions.jsonData !== newOptions.jsonData) {
            this.setState({ jsonData: newOptions.jsonData });
        }
    };
    GlobalNav.prototype.render = function () {
        var props = this.props;
        var options = this.props.options;
        var NavTag = "attwc-globalnav-" + options.type;
        var optionals = {
            dangerouslySetInnerHTML: props.data && props.data.html ? { __html: props.data.html } : undefined,
        };
        return (React.createElement(NavTag, __assign({ "customer-type": options.customerType }, optionals, { source: options.source, "data-contextualjson": options.jsonData, "exclude-core-elements": options.excludeCoreElements })));
    };
    return GlobalNav;
}(React.PureComponent));
exports.default = GlobalNav;
//# sourceMappingURL=GlobalNav.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@idp/ui-components/components/global/GlobalNav/GlobalNav.js
// module id = 1392
// module chunks = 8